import { Component, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { environment } from 'environments/environment';
import { Layout } from 'modules/layout';
import { CalendarEventModel } from 'models/generated/Identity.Api.Models.CalendarEvent';
import { Pipes } from 'modules/pipes';
import { UserPipe } from 'pipes/user.pipe';
import { SoftPopupComponent, TriggerSoftPopupDirective } from 'components/layout/soft-popup/soft-popup.component';
import { UserImageDirective } from 'directives/user-image.directive';

@Component({
	selector: 'absence',
	templateUrl: './absence.component.html',
	imports: [Layout, SoftPopupComponent, TriggerSoftPopupDirective, UserImageDirective, Pipes]
})
export class AbsenceComponent {

	private readonly baseUrl = `${environment.gatewayUrl}/api/calendar`;
	private readonly httpClient = inject(HttpClient);
	private readonly userPipe = inject(UserPipe);

	loading = true;
	eventCategories: { type: string; users: { id: string; name: string; start?: Date; end?: Date; missingImage?: boolean; }[]; }[] = [];
	eventTypes: Record<string, string> = {
		'10': 'sick',
		'29': 'sick',
		'33': 'sick',
		'81': 'sick',
		'35': 'sick-pregnant',
		'13': 'sick-child',
		'28': 'sick-child',
		'40': 'leave',
		'60': 'leave',
		'42': 'leave',
		'901': 'school',
		'30': 'other'
	};

	constructor() {
		this.loadCalendarEvents();
	}
	
	private async loadCalendarEvents() {
		const subjectMatch = /^godkendt fravær fra .* \-/i;
		const calendarEvents = await firstValueFrom(this.httpClient.get<CalendarEventModel[]>(this.baseUrl));
		const userIds: string[] = [];

		// Pick at most one event per userId, prioritized by the list of known "event types"
		for (const userId of calendarEvents.map(e => e.userId)) {
			if (!userId || userIds.indexOf(userId) >= 0) continue;

			const event: { userId: string, type: string, start?: Date, end?: Date } = { userId, type: 'unknown' };
			const userEvents = calendarEvents.filter(e => e.userId == userId);
			for (const type in this.eventTypes) {
				const matchingEvent = userEvents.find(e => e.subject.replace(subjectMatch, '').trim().startsWith(type));
				if (matchingEvent) {
					event.type = this.eventTypes[type];
					event.start = matchingEvent.start;
					event.end = matchingEvent.end;
					break;
				}
			}

			let category = this.eventCategories.find(c => c.type == event.type);
			if (!category) this.eventCategories.push(category = { type: event.type, users: [] });
			category.users.push({
				id: userId,
				name: this.userPipe.transform(userId, 'name'),
				start: event.start,
				end: event.end
			});
		}

		this.eventCategories.sort((c1, c2) => c1.type.localeCompare(c2.type));
		for (const category of this.eventCategories) category.users.sort((u1, u2) => u1.name.localeCompare(u2.name));

		this.loading = false;
	}
}
